import Select from 'react-select';
import { CustomStyle } from '../../../../../components/CustomSelectStyle';
import { CustomStyle as CustomStyleDarkTheme } from '../../../../../components/CustomSelectStyleDarkTheme';
import useThemeContext from '../../../../../contexts/theme';
import { Container } from './styles';
import filter from '../../../../../assets/images/icons/filter.svg';

interface FiltersInterface {
  activitiesList: { value: string; label: string }[];
  selectedActivity: { value: string; label: string };
  teacherRateOptions: { value: string; label: string }[];
  selectedTeacherRate: { value: string; label: string };
  contentRateOptions: { value: string; label: string }[];
  selectedContentRate: { value: string; label: string };
  durationRateOptions: { value: string; label: string }[];
  selectedDurationRate: { value: string; label: string };
  handleActivityChange: (activity: { value: string; label: string }) => void;
  handleTeacherRateChange: (rate: { value: string; label: string }) => void;
  handleContentRateChange: (rate: { value: string; label: string }) => void;
  handleDurationRateChange: (rate: { value: string; label: string }) => void;
}

export default function Filters({
  activitiesList,
  selectedActivity,
  teacherRateOptions,
  selectedTeacherRate,
  contentRateOptions,
  selectedContentRate,
  durationRateOptions,
  selectedDurationRate,
  handleActivityChange,
  handleTeacherRateChange,
  handleContentRateChange,
  handleDurationRateChange,
}: FiltersInterface) {
  const { selectedTheme } = useThemeContext();

  return (
    <Container>
      <header>
        <img src={filter} alt="filter" className="primaryColor" />
        <div>Pesquise através dos filtros abaixo</div>
      </header>

      <div>
        <Select
          value={{
            value: selectedActivity.value,
            label: selectedActivity.label === 'Todas' ? 'Filtrar por atividade' : selectedActivity.label,
          }}
          options={activitiesList}
          onChange={(activity) => handleActivityChange(activity as { value: string; label: string })}
          placeholder="Filtrar por atividade"
          styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
          classNamePrefix="react-select"
          className="react-select-container-as-filter"
        />
      </div>

      <div>
        <Select
          value={{
            value: selectedTeacherRate.value,
            label: selectedTeacherRate.label === 'Todas' ? 'Filtrar por nota do professor' : selectedTeacherRate.label,
          }}
          options={teacherRateOptions}
          onChange={(rate) => handleTeacherRateChange(rate as { value: string; label: string })}
          placeholder="Filtrar por nota do professor"
          styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
          classNamePrefix="react-select"
          className="react-select-container-as-filter"
        />
        <Select
          value={{
            value: selectedContentRate.value,
            label: selectedContentRate.label === 'Todas' ? 'Filtrar por nota do conteúdo' : selectedContentRate.label,
          }}
          options={contentRateOptions}
          onChange={(rate) => handleContentRateChange(rate as { value: string; label: string })}
          placeholder="Filtrar por nota do conteúdo"
          styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
          classNamePrefix="react-select"
          className="react-select-container-as-filter"
        />
        <Select
          value={{
            value: selectedDurationRate.value,
            label: selectedDurationRate.label === 'Todas' ? 'Filtrar por duração' : selectedDurationRate.label,
          }}
          options={durationRateOptions}
          onChange={(rate) => handleDurationRateChange(rate as { value: string; label: string })}
          placeholder="Filtrar por duração"
          styles={selectedTheme === 'dark' ? CustomStyleDarkTheme : CustomStyle}
          classNamePrefix="react-select"
          className="react-select-container-as-filter"
        />
      </div>
    </Container>
  );
}
